import React from 'react';
import TimeSlot from './TimeSlot';
import { generateTimeSlots } from '../utils/storage';

const DayView = ({ selectedDate, reservations, onTimeSlotClick, onDeleteReservation, settings }) => {
  const timeSlots = generateTimeSlots(settings.startHour, settings.endHour, reservations);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {timeSlots.map((timeSlot) => (
        <TimeSlot
          key={timeSlot}
          timeSlot={timeSlot}
          reservation={reservations[timeSlot]}
          onTimeSlotClick={onTimeSlotClick}
          onDeleteReservation={onDeleteReservation}
        />
      ))}
    </div>
  );
};

export default DayView; 